import { OktonAccessDenied, OktonLoadingState } from '@okton/platform-ui';
import React from 'react';
import {
  Redirect,
  Route as ReactDOMRouter,
  RouteProps as ReactDOMRouteProps,
} from 'react-router-dom';

import { useAuth } from '../hooks/auth';
import { TypePermissoes, usePermissoes } from '../services/hooks/usePermissoes';

interface IRouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
  permissao?: TypePermissoes;
}

const Route: React.FC<IRouteProps> = ({
  isPrivate = false,
  component: Component,
  permissao,
  ...rest
}: IRouteProps) => {
  const { user, isLoading } = useAuth();
  const { permite } = usePermissoes();

  return (
    <ReactDOMRouter
      {...rest}
      render={({ location }) => {
        if (isLoading) {
          return <OktonLoadingState title="Carregando..." minH="100vh" />;
        }

        if (isPrivate !== !!user) {
          return (
            <Redirect
              to={{
                pathname: isPrivate ? '/login' : '/dashboard',
                state: { from: location },
              }}
            />
          );
        }

        if (isPrivate && permissao && !permite(permissao)) {
          return <OktonAccessDenied />;
        }

        return <Component />;
      }}
    />
  );
};

export default Route;
